import React, { useContext, useState } from "react";

//styles
import Checkbox from "../../../Forms/Checkbox/Checkbox";
import { IProviderAddon } from "../../../../../compare/interfaces/IProviderAddon";
import { QuoteGroupContext } from "../../../../../compare/providers/RootContextProvider";
import { selectProviderAddOnAPI } from "../../../../../compare/api/endpoints/ApiQuotes";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import { FeatureFlag } from "../../../../../compare/enums/FeatureFlags";
import Icon from "../../../Icon/Icon";
import useLightwindow from "../../../../hooks/useLightwindow";
import styles from "../AIAVitality/AIAVitalityAddOn.module.scss";
import cx from "classnames";

interface IChubbLifetimeRewardAddOnProps {
    addOn: IProviderAddon;
    size: "small" | "full";
}

const ChubbLifetimeRewardAddOn: React.FC<IChubbLifetimeRewardAddOnProps> = (props) => {
    const { addOn } = props;
    const { selectors, actions } = useContext(QuoteGroupContext);

    const [isSelected, setIsSelected] = useState(selectors.isProviderAddOnSelected(addOn.systemName));

    const { openPromotion } = useLightwindow();

    const updateSelection = async (isSelected: boolean): Promise<void> => {
        setIsSelected(isSelected);
        actions.setIsProviderAddOnSelected(addOn.systemName, isSelected);

        const groupId = selectors.getGroupId();
        await selectProviderAddOnAPI(groupId, addOn.systemName, isSelected);
    };

    return (
        <SplitTreatments names={[FeatureFlag.ChubbLifeTimeReward]}>
            {({treatments, isReady}) => {
                if (window.splitioFactory && !isReady) return null;

                const treatment = treatments[FeatureFlag.ChubbLifeTimeReward].treatment;

                if (treatment === "on") {
                    return (
                        <React.Fragment>
                            <div className="layout-flex-row gap-m">
                                <Checkbox size="l" name="lifetime-reward" checked={isSelected} onChange={(e) => updateSelection(e.target.checked)} />
                                <span className={cx(styles["mobile-heading"], "space-pre-m gap-pre-xs text-font-size-s text-bold")}>
                                    Lifetime Reward
                                </span>
                            </div>
                            <span>For a limited time, Chubb Life's Lifetime Reward includes a 15% discount if you fit within it's eligibility criteria. </span>
                            {<a onClick={() => openPromotion("ChubbLifetimeReward")}>Info</a>}
                        </React.Fragment>
                    );
                } else {
                    return (
                        <React.Fragment>
                                <a
                                href="https://www.chubb.com/content/dam/chubb-sites/chubb/nz-en/life/documents/final-10-percent-lifetime-reward-faqs-260623_1.pdf"
                                    target="_blank"
                                    rel="noopener">
                                    Lifetime Reward
                            </a>
                                <Icon className="space-pre-m" id="ExternalLink" />
                        </React.Fragment>
                    );
                }
            }}

        </SplitTreatments>
    );
};

export default ChubbLifetimeRewardAddOn;
